import { BarChart as MuiBarChart } from '@mui/x-charts/BarChart';

import { BarChartProps } from './types';
import { Container } from './styles';

export function BarChart({ title, ...props }: BarChartProps) {
  return (
    <Container>
      {title && <strong>{title}</strong>}

      <MuiBarChart {...props} />
    </Container>
  );
}
